// =========================== Motion ===========================
const genRtlStyle = token => {
  const {
    componentCls
  } = token;
  return {
    ["".concat(componentCls, "-rtl")]: {
      direction: 'rtl'
    }
  };
};
export default genRtlStyle;